import React from 'react';
import { Card } from '../../atoms/card/card.atom';
import { SuggestionItem } from '../../molecules/suggestion-item/suggestion-item.molecule';
import { ThankYouContainer } from '../../atoms/thank-you-container/thank-you-container.atom';
import { Divider } from '../../atoms/divider/divider.atom';
import { Text } from '../../atoms/text/text.atom';
import { ThankYouTitle } from '../../atoms/thank-you-title/thank-you-title.atom';
import { ErrorIcon } from '../../atoms/error-icon/error-icon.atom';
import { Button } from '../../atoms/button/button.atom';
import { useTranslation } from 'react-i18next';

type Props = {
  onRetry: () => void;
};

export const PaymentDeclinedBody: React.FC<Props> = ({ onRetry }) => {
  const { t } = useTranslation();
  return (
    <Card>
      <ThankYouContainer textAlign="center">
        <ErrorIcon />
        <ThankYouTitle size="1.75rem" weight="700" color="#1f2937">
          {t('purchaseNotApprovedMessage')}
        </ThankYouTitle>
        <Text size="1.125rem" color="#4b5563" align="center">
          {t('paymentIssueButDontWorry')}
          <br />
          {t('thisCanHappenForManyReasons')}
        </Text>
      </ThankYouContainer>

      <Divider />

      <ThankYouContainer margin="1.5rem 0">
        <ThankYouTitle size="1.25rem" weight="600">
          {t('tryAgainPrompt')}
        </ThankYouTitle>
        <Text size="1rem" color="#4b5563">
          {t('youCan')}
        </Text>

        <ThankYouContainer margin="1rem 0">
          <SuggestionItem text={t('verifyCardInfo')} />
          <SuggestionItem text={t('tryAnotherPayment')} />
          <SuggestionItem text={t('contactSupport')} />
        </ThankYouContainer>
      </ThankYouContainer>

      <Divider />

      <ThankYouContainer textAlign="center">
        <ThankYouContainer
          margin="0 0 1rem"
          style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}
        >
          <Button onClick={onRetry}>{t('tryAgain')}</Button>
        </ThankYouContainer>
        <Text size="0.875rem" color="#6b7280">
          {t('needHelp')}{' '}
          <a href="#" style={{ color: '#049366', textDecoration: 'none' }}>
            {t('contactOurSupport')}
          </a>
        </Text>
      </ThankYouContainer>
    </Card>
  );
};
